import type { WavespeedSpeechModelConfig } from '../types';

export const googleConfigs: Record<string, WavespeedSpeechModelConfig> = {
    'lyria-3-clip': {
        // https://wavespeed.ai/zh-CN/models/google/lyria-3-clip/music
        apiPath: '/google/lyria-3-clip/music',
        enableTranslation: false,
        buildInput: ({ text, providerOptions }) => {
            return {
                prompt: text,
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // system
                image: undefined,
            };
        },
    },
    'lyria-3-pro': {
        // https://wavespeed.ai/zh-CN/models/google/lyria-3-pro/music
        apiPath: '/google/lyria-3-pro/music',
        enableTranslation: false,
        buildInput: ({ text, providerOptions }) => {
            return {
                prompt: text,
                negative_prompt: typeof providerOptions?.negative_prompt === 'string' ? providerOptions.negative_prompt : undefined,
                seed: typeof providerOptions?.seed === 'number' ? providerOptions.seed : undefined,
                // system
                image: undefined,
            };
        },
    },
};